import i18n, { i18nPt, i18nEn } from '@/i18n';
import { forcedSiteLanguage } from '@/lib/country';

/**
 * `t` FIJO en el idioma del TENANT, no en el del visitante.
 *
 * Para todo lo que lee la AUTOMOTORA (asuntos de los correos de aviso, motivo de
 * la cita en ese asunto…): el visitante puede estar mirando el sitio en otro
 * idioma —un tenant chileno con selector y el visitante en inglés—, pero el
 * aviso le llega a la automotora en SU idioma:
 *   - EE.UU. → inglés (instancia `i18nEn`);
 *   - Brasil → portugués (instancia `i18nPt`, como hoy);
 *   - el resto → español SIEMPRE (la global con `getFixedT('es')`): es lo que
 *     recibía la automotora antes de que existieran las traducciones en inglés
 *     de estos textos (caían al español por fallback).
 */
export const tDelTenant = (country?: string | null): ((key: string) => string) => {
  const forzado = forcedSiteLanguage(country);
  const fijo =
    forzado === 'pt'
      ? i18nPt.getFixedT('pt')
      : forzado === 'en'
        ? i18nEn.getFixedT('en')
        : i18n.getFixedT('es');
  return (key: string) => String(fijo(key));
};
